module.exports = __webpack_public_path__ + "img/Bodice-Back-Sleeve1-Kb-Ld.2a675fac.png";